<template>
  <div class="card-item scab" style="height: 50%;">
    <div class="subtitle">
      赤霉病预警仪
    </div>

    <table border="0" cellspacing="0" cellpadding="0">
      <thead>
        <tr>
          <th>
            <div class="cell">日期</div>
          </th>
          <th>
            <div class="cell">预测结果</div>
          </th>
        </tr>
      </thead>
      <tbody ref="scroller" :style="`height: ${height - 82}px;`">
        <tr v-for="item in predict" :key="item.label">
          <td>
            <div class="cell">{{ item.label }}</div>
          </td>
          <td>
            <div class="cell">{{ item.value }}</div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import mixin from '../mixin'
import { getToken, getPredict } from '@/service/wheat'

export default {
  mixins: [mixin],
  data() {
    return {
      index: 0,
      timer: null,
      token: '',
      predict: [
        { label: '1日(今天)', value: '无预测' },
        { label: '2日', value: '无预测' },
        { label: '3日', value: '无预测' },
        { label: '4日', value: '无预测' },
        { label: '5日', value: '无预测' },
        { label: '6日', value: '无预测' },
        { label: '7日', value: '无预测' }
      ]
    }
  },
  computed: {
    device() {
      return this.scabs[0] || {}
    }
  },
  async mounted() {
    if (this.scabs.length) {
      await this.getToken()
      this.getPredict()
    }
    this.timer = setInterval(this.scrollTo, 10)
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    async getToken() {
      const { data } = await getToken()
      this.token = data.token
    },
    async getPredict() {
      const { data } = await getPredict(this.device.id)
      this.predict = this.formatPredict(data)
    },
    formatPredict(raw) {
      let data = raw.data && raw.data[0] ? raw.data[0] : {}
      let keys = [
        { key: 'first', label: '1日(今天)' },
        { key: 'second', label: '2日' },
        { key: 'third', label: '3日' },
        { key: 'forth', label: '4日' },
        { key: 'fifth', label: '5日' },
        { key:'sixth', label: '6日' },
        { key: 'seventh', label: '7日' }
      ]
      return keys.map(k => ({
        label: k.label,
        value: data[k.key] || '暂无数据'
      }))
    },
    scrollTo() {
      let el = this.$refs.scroller
      if (!el) return
      if (this.index === 0) {
        el.scrollTo(0, 0)
        clearInterval(this.timer)
        this.index++
        setTimeout(() => {
          this.timer = setInterval(this.scrollTo, 10)
        }, 2000)
      } else {
        let height = 7 * 32 - el.offsetHeight
        let y = this.index * 0.2
        if (y > height) {
          clearInterval(this.timer)
          this.index = 0
          setTimeout(() => {
            this.timer = setInterval(this.scrollTo, 10)
          }, 2000)
        } else {
          el.scrollTo(0, y)
          this.index++
        }
      }
    }
  },
  watch: {
    predict() {
      let height = 7 * 32 - this.$refs.scroller.offsetHeight
      if (height > 0) {
        this.index = 0
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.card-item.scab {
  overflow: hidden;
  table {
    padding: 0 20px;
    width: 100%;
    text-align: left;
    thead {
      background-color: #84aaf15e;
      border: none;
    }
    th,
    td {
      padding: 8px 0;
      box-sizing: border-box;
    }
    tbody {
      display: block;
      overflow-y: hidden;
    }

    tr {
      display: table;
      width: 100%;
      table-layout: fixed;
      text-align: center;
    }
    tbody tr:nth-child(even) td,
    tbody tr:nth-child(even) td {
      background-color: rgba(20, 53, 114, 0.5);
    }

    .cell {
      padding: 0 8px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      text-align: left;
    }
  }
}
</style>
